import {
    checkDiff,
    checkForPastDate,
    checkForPastTime,
    validateDate,
    validateDateOnOrBeforeRepeatUntilDate,
    validateEndTime,
    validateStartTime
} from './validationFunctions';

export const validateUserEvent = (newEntry, initialStateOnEntry) => {
    let newErrors = {};
    newErrors = validateStartTime(newEntry.startTime, newEntry.endTime, newErrors);
    newErrors = validateEndTime(newEntry.endTime, newEntry.startTime, newErrors);

    newErrors = validateDate(newEntry.date, newErrors);
    if (newEntry.date) newErrors = checkForPastDate(newEntry.date, newErrors);

    if (!newErrors?.date?.error)
        newErrors = checkForPastTime(newEntry.date, newEntry.startTime, newErrors);

    if (newEntry.repeat !== 'NO_REPEAT')
        newErrors = validateDateOnOrBeforeRepeatUntilDate(
            newEntry.date,
            newEntry.repeatUntilDate,
            newErrors
        );

    if (Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialStateOnEntry, newErrors);

    return newErrors;
};
